import { useParams, Link } from "react-router-dom";
import { Markdown } from "./markdown";
import { TableOfContents } from "./TableOfContents";

// Bundle markdown at build time — no runtime fetch.
const MODULES = import.meta.glob("./pages/*.md", {
  query: "?raw",
  import: "default",
  eager: true,
});

function pageFor(slug: string): string | null {
  const match = Object.entries(MODULES).find(([path]) =>
    path.endsWith(`/pages/${slug}.md`),
  );
  return match ? (match[1] as string) : null;
}

export function DocsPage() {
  const { slug } = useParams();
  const content = slug ? pageFor(slug) : null;

  if (!content) {
    return (
      <div className="p-4 border border-border rounded-md bg-muted/40">
        <h2 className="text-lg font-semibold mb-2">Doc not found</h2>
        <p className="text-sm text-muted-foreground">
          No documentation page matches <code>{slug}</code>.
        </p>
        <div className="mt-3">
          <Link
            to="/docs/getting-started"
            className="text-sm text-primary underline underline-offset-2 hover:no-underline"
          >
            ← Back to Getting Started
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="flex gap-6">
      <div className="flex-1 min-w-0">
        <Markdown>{content}</Markdown>
      </div>
      <TableOfContents markdown={content} />
    </div>
  );
}
